import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const EmployeesAndHQWrapper = styled.div`
  margin: 20px 0;
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

export const Header = styled.div`
  ${cardHeaderStyles};
  justify-content: space-between;
`;

export const Content = styled.div`
  ${cardContentStyles};
  justify-content: space-between;
`;

export const Employees = styled.div`
  flex: 1;
`;

export const Headquarters = styled.div`
  flex: 1;
`;

interface IEmployeesCountProps {
  employeesCount?: boolean;
}

export const EmployeesCount = styled.div`
  flex: 1;
  font-size: ${(props: IEmployeesCountProps) =>
    props.employeesCount ? "2.25em" : "1em"};

  ${mediaMaxWidth.tablet} {
    font-size: ${(props: IEmployeesCountProps) =>
      props.employeesCount ? "2em" : "1em"};
  }
`;

export const HeadquartersAddress = styled.div`
  flex: 1;
`;

export const MapLink = styled.a`
  display: block;
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  text-decoration: underline !important;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;
